
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gbngWcMNVPzOIoLaB84u0QQ2_UXL3E7F1IlLnQJNACUUMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexh0eHMsSQOBtRK4x0HRPJLqEEcqwEcX1KtHkZNmh4w8oMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchlyBk7Xy7kKS4PbCaz5l7CH7Ciy_FHiV_pLue71d77NoMeta } from "/home/runner/work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexndi3lvKUljgTk7rAIsKFOMMeteWu3_DZrW39SF5PmpMMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93W_LTEyWQFzUFQCOqZ2lTrIHd2RwecPOkZf4fQSzgD0AMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index2oD3MUb2APTjn7mGIhGFP65zJNXVSzqq_YqnU3N0RXoMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Vf8vtuj8z_45R8BYqw_45LqcYOTapc99uuK4z_s4Qi8qVtIMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexbTSv2ePO4nIHVroZ1fsD6vGC9YYPTT5nnXs6K69s5IcMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93JVoy_45XwZJ4I71Vl5P0eFXufWN7Zd7j4RvaDixEw8VNMMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index1iksIUkXMbcRuDLtjYVUsjU7fAOvHuF5ZEfWgHedTp8Meta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index2bdoBp2eoJXrZIZ2rX9sO7RR2WAFuus4ixABde_OsWgMeta } from "/home/runner/work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/runner/work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index2oD3MUb2APTjn7mGIhGFP65zJNXVSzqq_YqnU3N0RXoMeta || {},
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexbTSv2ePO4nIHVroZ1fsD6vGC9YYPTT5nnXs6K69s5IcMeta || {},
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index1iksIUkXMbcRuDLtjYVUsjU7fAOvHuF5ZEfWgHedTp8Meta || {},
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index2bdoBp2eoJXrZIZ2rX9sO7RR2WAFuus4ixABde_OsWgMeta || {},
    component: () => import("/home/runner/work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]